import { TextInput, TextInputProps } from './text-input';
import { forwardRef } from 'react';
import { FieldError } from 'react-hook-form';
import { NumericFormat, NumericFormatProps } from 'react-number-format';

type CustomNumericFormatProps = Omit<
  NumericFormatProps<{ error?: FieldError; allowEmptyFormatting?: boolean }>,
  'onValueChange' | 'value' | 'onChange' | 'size' | 'type'
>;

type CustomTextInputProps = Omit<TextInputProps, 'onChange' | 'value' | 'type'>;

export type NumberInputProps = CustomNumericFormatProps &
  CustomTextInputProps & {
    value?: number | null;
    onChange?: (value: number | undefined | null) => void;
  };

export const NumberInput = forwardRef<HTMLInputElement, NumberInputProps>(
  ({ error, value, onChange, ...rest }, ref) => {
    return (
      <NumericFormat
        customInput={TextInput}
        displayType="input"
        value={value === undefined || value === null ? '' : value}
        onValueChange={(values, { source }) => {
          if (source === 'event') {
            onChange?.(values.value === '' ? null : values.floatValue);
          }
        }}
        getInputRef={ref}
        {...rest}
        error={error}
      />
    );
  }
);

NumberInput.displayName = 'NumberInput';
